import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import SecureLS from 'secure-ls'
import { setAuthorizationHeader } from 'src/api/userAPI'
import {
  loginHandler,
  logoutSuccess,
  updatePlanSuccess,
  updateShowSideBar,
  updateSuccess,
  updateCompanySuccess,
  updateProfilePicture,
} from './authSlice'

const secureLs = new SecureLS()

const updateStateInStorage = (newState) => {
  secureLs.set('appc-auth-mkplace', newState)
}

const listenerMiddleware = createListenerMiddleware()

const effect = (action, listenerApi) => {
  const currentState = listenerApi.getState().authReducer.user
  updateStateInStorage(currentState)

  if (action?.meta?.requestStatus === 'fulfilled') {
    setAuthorizationHeader(currentState)
  }
}

listenerMiddleware.startListening({
  matcher: isAnyOf(
    loginHandler,
    logoutSuccess,
    updateSuccess,
    updatePlanSuccess,
    updateShowSideBar,
    updateCompanySuccess,
    updateProfilePicture,
  ),
  effect,
})

export default listenerMiddleware.middleware
